
// src/web/components/diary-title.jsx

import React from 'react'
import moment from 'moment'
import { translate } from 'react-i18next'
import { convertEmojiHTML } from '../../helpers/emoji-helpers'
import { FontIcon } from 'react-toolbox/lib/font_icon'

const groupStyle = {
  color: '#999',
  marginLeft: '1em',
  fontSize: '80%',
  cursor: 'pointer',
  display: 'inline-block'
}

const unreadMarkStyle = {
  background: '#20B2AA',
  width: '0.8em',
  height: '0.8em',
  borderRadius: '50%',
  display: 'inline-block',
  verticalAlign: 'middle',
  marginLeft: '5px',
}

function DiaryTitlte(props) {
  const {
    t,
    diary,
    unread,
    showGroup,
  } = props

  var subject
  if (diary.subject) {
    subject = <span dangerouslySetInnerHTML={{__html: convertEmojiHTML(diary.subject)}} />
  }
  else {
    subject = <span>
        {t('format:diary_subject', {
          reported_at: diary.reported_at,
          category: t('diary:'+diary.category)
        })}
      </span>
  }

  var group
  if (diary.group) {
    group = <div style={groupStyle} onClick={showGroup}>
              <FontIcon style={{ fontSize: '80%' }} value="keyboard_arrow_right"/>
              {diary.group.name}
            </div>
  }

  var unreadMark
  if (unread)
    unreadMark = <span style={unreadMarkStyle}></span>

  return group && <span>{subject}{group} {unreadMark}</span> || <span>{subject} {unreadMark}</span>
}

export default translate()(DiaryTitlte)



// WEBPACK FOOTER //
// ./src/web/components/diary-title.jsx